import React from "react";
import "./CardPlaceholder.scss";

const CardPlaceholder = ({ children }) => {
  return <div className="card-placeholder">{children}</div>;
};

export default CardPlaceholder;
